import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { getInstance } from "../../../../API/DocQuery";
import { getModel } from "../../../../API/ModelList";
import { applyFilters, filterByModel } from "../../../Utils/FiltersManager";
import { applySort } from "../../../Utils/SortManager";
import "./LotsTable.css";
import NavBar from "../../../Navbar/Navbar";
import Ariane from "../../../Utils/Ariane";
import LotStat from "../LotStat/LotStat";
import { parseCustomDate } from "../../../Utils/DateManager";
import FullTableConfig from "../../FullTableConfig.json";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLotsState } from "../../../Utils/FiltersManager";
import LotsTableComponent from "./LotsTableComponent";

const LotsTable = ({ configKey }) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modelName, setModelName] = useState([]);
  const [modelInstanceStatuses, setModelInstanceStatuses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const modelId = Cookies.get("modelId");
  const clientId = Cookies.get("clientId");
  const config = FullTableConfig[configKey];
  const {
    setCurrentPage,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    dateRangeFilter,
    setDateRangeFilter,
  } = useLotsState();

  // Initialise le filtre depuis le localStorage (ou vide si non défini)
  const [filter, setFilter] = useState(() => {
    try {
      const storedFilter = localStorage.getItem("filter_lots");
      return storedFilter ? JSON.parse(storedFilter) : {};
    } catch (e) {
      console.error("Erreur parsing localStorage filter:", e);
      return {};
    }
  });

  // Récupère les données des modèles et instances au chargement du composant
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const idToken = Cookies.get("Token");
        const modelData = await getModel(idToken);

        setModelName(
          modelData.map((model) => ({
            id: model.ModelId,
            name: model.ModelName,
            component: model.ModelComponent,
          })),
        );

        if (modelData && modelData.length > 0) {
          const instanceStatuses = modelData[0].ModelInstanceStatus;
          setModelInstanceStatuses(instanceStatuses);
        }

        let selectedModelId = Cookies.get("modelId");

        if (!selectedModelId && modelData.length === 1) {
          selectedModelId = modelData[0].ModelId;
          Cookies.set("modelId", selectedModelId);
        }

        const allComponentsUndefined = modelData.every(
          (model) => model.ModelComponent === undefined,
        );

        if (modelData.length > 1 && allComponentsUndefined) {
          selectedModelId = undefined;
          Cookies.remove("modelId");
        }

        const responseData = await getInstance(idToken, selectedModelId);
        setData(responseData);
      } catch (error) {
        console.error("Erreur lors du chargement des données", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Applique les filtres et met à jour les données filtrées
  useEffect(() => {
    const dataAfterFilters = applyFilters(
      data,
      filter,
      dateRangeFilter,
      parseCustomDate,
    );
    const dataAfterModelFilter = filterByModel(dataAfterFilters, filter);
    setFilteredData(dataAfterModelFilter);
  }, [data, filter, dateRangeFilter, parseCustomDate]);

  // Gère le changement de configuration (modèle) et recharge la page
  const handleConfigKeyChange = (component) => {
    const newConfigKey =
      component.charAt(0).toUpperCase() + component.slice(1) + "Lots";
    setCurrentPage(1);
    setSortField("dCreationDate");
    setSortOrder("desc");

    window.location.href = `/User/${newConfigKey}`;
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  const sortedData = applySort(filteredData, sortField, sortOrder);

  return (
    <>
      <NavBar />
      <div className="Ariane_LotStat_style">
        <Ariane
          modelName={modelName}
          onChangeConfigKey={handleConfigKeyChange}
        />
        <LotStat
          lots={data}
          onFilterClick={(filterKey) => {
            setFilter((prev) => {
              if (!filterKey) {
                return { ...prev, sStatus: "", filterKey: null };
              }

              // Si c'est un compteur (iXXXDocs)
              if (filterKey.startsWith("i")) {
                return { ...prev, sStatus: "", filterKey };
              }

              // sinon c'est un status
              return { ...prev, sStatus: filterKey, filterKey: null };
            });
          }}
        />
      </div>

      <LotsTableComponent
        data={data}
        setData={setData}
        modelId={modelId}
        clientId={clientId}
        page="TabLots"
        config={config}
        filter={filter}
        setFilter={setFilter}
        configKey={configKey}
        modelInstanceStatuses={modelInstanceStatuses}
        dateRangeFilter={dateRangeFilter}
        setDateRangeFilter={setDateRangeFilter}
      />
    </>
  );
};

export default LotsTable;
